import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { FleetPage } from '../../../../shared/sso-workspace/fleet-page'
import { usePlatformOrganization } from '../../org/api-keys/platform-organization'
import { SysKeysTab } from './sys-keys-tab'
import { SysUsageTab } from './sys-usage-tab'

// Staff oversight of API keys (Phase D D8/D9/D11; plan Task 16), like the
// organization's page for every organization at once: the keys (revoke any,
// change a key's rate limit) and usage with its CSV export, as tabs in
// ?tab=. An organization's partner API access is switched on its own page
// (admin/organization/page/organization-edit/api-access-toggle.js): the list's
// organization and its "Access off" lead there.
//
// The Keys list's add action is New platform key (owner 2026-10-23,
// new-platform-key.js), in the Keys card's header (sys-keys-tab.js; owner
// 2026-10-29, the house list page): a key of the platform organization,
// EducationXR's own, which the list calls "Platform" and its organization
// filter offers as "Platform keys" (platform-organization.js says which
// organization that is).
// There is no "new key for an organization" here: a key is always made in the
// organization the session is in, no route lets staff make one in another
// organization, so an ordinary organization's keys are made by its admins on
// its own API keys page once its access is on.
export const TABS = [
  { key: 'keys', label: 'Keys', Component: SysKeysTab },
  { key: 'usage', label: 'Usage', Component: SysUsageTab }
]

export const SysApiKeysPage = () => {
  const { search } = useLocation()
  const asked = new URLSearchParams(search).get('tab')
  const tab = TABS.find(t => t.key === asked) || TABS[0]
  const platform = usePlatformOrganization()

  return (
    <FleetPage title="API keys"
      purpose="Every organization's API keys and their usage. Platform keys are EducationXR's own. An organization's partner API access is switched on its organization page."
      testId="sys-api-keys-page">
      <nav className="sw-tabs" aria-label="API keys">
        {TABS.map(t =>
          <NavLink key={t.key} to={`/admin/api-keys?tab=${t.key}`} isActive={() => t.key === tab.key} activeClassName="active"
            aria-current={t.key === tab.key ? 'page' : undefined}>{t.label}</NavLink>)}
      </nav>
      <tab.Component platform={platform} />
    </FleetPage>
  )
}
